import { render } from "./myNewWorks.vue?vue&type=template&id=600be386&scoped=true"
import script from "./myNewWorks.vue?vue&type=script&lang=js"
export * from "./myNewWorks.vue?vue&type=script&lang=js"

import "./myNewWorks.vue?vue&type=style&index=0&id=600be386&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600be386"]])

export default __exports__